import { Injectable } from "@angular/core";
import { AppSettings } from "@app/common/app-setting";
import { HttpClient } from '@angular/common/http';
import { ProfileDetialsModel } from "@app/models/ProfileDetailsModel";
import { AutharizedEndPointService } from "@app/services/base-service/autharized-endpoint.service";
import { debug } from "util";
import { IMerchantProfile } from "@app/models/dashboard/patanjali-dashboard.model";

@Injectable()
export class ProfileDetailsEndPoint extends AutharizedEndPointService{
  http1 : HttpClient;
  _baseurl = `${AppSettings.API_ENDPOINT}`;
    private readonly _getSaveCustomerBasicInfoUrl: string = 'api/usermanagement/UpdateProfile';
    private readonly _getUserDataUrl: string = '/api/usermanagement/GetCustomerProfile';
    private readonly _getLocationUrl: string = 'api/CommonAppController/GetStatesAndCity/';
    private readonly _getUserMerchantDataUrl: string = '/api/MerchantDashboardReport/GetProfileDetails';
    private readonly _getMerchantDataUrl: string = '/api/MerchantDashboardReport/GetMerchantProfileDetails/';
    profileDetails: ProfileDetialsModel;
    constructor(http: HttpClient) {
        super(http, 'UserManagement/Roles');
        this.http1 = http;
      }
      
    getUrl(url: string) {
        return this._baseurl + url;
    }

    updateCustomerProfileDetails(profileDetails: ProfileDetialsModel){
        return this.http1.post(this.getUrl(this._getSaveCustomerBasicInfoUrl),profileDetails, this.AddAuthToken());
    }

    getUserData() {
        return this.http1.get<ProfileDetialsModel>(this.getUrl(this._getUserDataUrl), this.AddAuthToken());
    }
    getUserMerchantData() {
        return this.http1.get<IMerchantProfile>(this.getUrl(this._getUserMerchantDataUrl),this.AddAuthToken());
    }
    getMerchantDetails(EntityId:number) {
        return this.http1.get<IMerchantProfile>(this.getUrl(this._getMerchantDataUrl)+EntityId,this.AddAuthToken());
    }

    getLocationData(id: number){
        return this.http1.get<ProfileDetialsModel>(this.getUrl(this._getLocationUrl) +id);
    }

    getCityData(id: number){
        return this.http1.get<ProfileDetialsModel>(this.getUrl(this._getLocationUrl) +id);
    }
    getRegistrationNumber() {
        return this.http1.get<ProfileDetialsModel>(this.getUrl(this._getUserDataUrl), this.AddAuthToken());
    }
}  


// WEBPACK FOOTER //
// ./src/app/services/customerProfile/profile-details-endpoint.service.ts